// tslint:disable
// this is an auto generated file. This will be overwritten

export const getShow = `query GetShow($id: ID!, $timeStart: AWSDateTime!) {
  getShow(id: $id, timeStart: $timeStart) {
    id
    username
    timeStart
    timeEnd
    platform
  }
}
`;
export const listShows = `query ListShows(
  $filter: TableShowFilterInput
  $limit: Int
  $nextToken: String
) {
  listShows(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      timeStart
      timeEnd
      platform
    }
    nextToken
  }
}
`;
export const queryShowsByIdUsernameIndex = `query QueryShowsByIdUsernameIndex($id: ID!, $first: Int, $after: String) {
  queryShowsByIdUsernameIndex(id: $id, first: $first, after: $after) {
    items {
      id
      username
      timeStart
      timeEnd
      platform
    }
    nextToken
  }
}
`;
